module.exports = __webpack_public_path__ + "static/media/iconCanvas08.35697cb9.svg";